export const CONNECT_AUTO_SCALE_SCALE_READ_SUCCESS = 'CONNECT_AUTO_SCALE_SCALE_READ_SUCCESS';
export const scaleReadSuccess = (message) => ({
  type: CONNECT_AUTO_SCALE_SCALE_READ_SUCCESS,
  message,
});
